import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import GrammarMenuRight from 'app/components/layouts/MenuRight/Grammar';
import SearchForm from 'app/commons/components/SearchForm';
import { withGlobalData } from 'app/utils/withGlobalData';
import Paginate from 'app/commons/components/Paginate';
import { findTranslate } from 'app/utils/translate';
import { ResultAPI } from 'app/requests/apiRequest';
import { buildParams } from 'app/utils/pagination';
import Image from 'app/components/layouts/Image';
import Title from 'app/components/layouts/Title';
import { useTranslation } from 'next-i18next';
import * as blogApi from 'app/requests/blogs';
import { setNewParams } from 'app/utils/ga';
import { useRouter } from 'next/router';
import { NextSeo } from 'next-seo';
import { Blog } from 'types/blog';
import { useState } from 'react';
import Link from 'next/link';
import env from '.env.json';
import 'app/components/blogs/styles.css'

export default function Index({ blogs }) {
  const router = useRouter();
  const { t } = useTranslation();
  const [params, setParams] = useState({
    page: router.query.page || 1,
    keyword: router.query.keyword || ''
  });

  const listNews = () => {
    const lists = (blogs.data || []).map((blog: Blog) => {
      const image = blog.thumbnail || blog.image;
      const slug = blog[`slug_${router?.locale}`];
      const title = findTranslate(blog?.translates, 'title', router?.locale);
      const description = findTranslate(blog?.translates, 'description', router?.locale);

      return (
        <Link key={blog.id} href={`/news/${slug}`}>
          <article className="row mb-4 article-container cursor-pointer">
            <div className="col-md-4">
              <div className="image-card">
                <Image
                  src={`${env.URL_APP_FILE || env.URL_API}/storage/${image}`}
                  alt={title}
                />
              </div>
            </div>
            <div className="content col-md-8">
              <p className="text-title text-info text-truncate mb-0">{title}</p>
              <span className='text-dark'>
                {description}
              </span>
            </div>
          </article>
        </Link>
      )
    })
    return lists;
  }

  const setDataParams = (value: string | number, name: string, page: number|null = null) => {
    setNewParams(setParams, params, value, name, page);
    let newParams = { ...params, [name]: value };
    if (page) newParams.page = page;

    setParams(newParams);
    const url = `/news/${buildParams(newParams)}`
    router.push(url)
  }

  return (
    <section className="news box-card-area list-news">
      <NextSeo title={t('news.title')} />
      <div className="container-md">
        <div className="d-flex">
          <div className="box-news-area">
            <div className='content_inner'>
              <Title title='news.title' />
              <div className='form-group mt-3 mb-5 mx-auto col-md-6'>
                <SearchForm setDataParams={setDataParams} />
              </div>
              {blogs && blogs.data.length > 0 &&
                <div className="mt-10">
                  <div>
                    {listNews()}
                  </div>
                  <Paginate
                    data={blogs}
                    handleChangePage={(page: number) => setDataParams(page, 'page')}
                  />
                </div>
              }
              {blogs.data && !blogs.data.length &&
                <div className='text-danger text-center mt-3 text-size-xl'>
                  {t('commons.result_notfound')}
                </div>
              }
            </div>
          </div>
          <GrammarMenuRight />
        </div>
      </div>
    </section >
  )
}

export const getServerSideProps = withGlobalData(async ({ locale, query }) => {
  const CATEGORY_BLOG_ID = 2;

  try {
    const [blogsRes, translations] = await Promise.all([
      blogApi.getBlogs({
        ...query,
        category_id: CATEGORY_BLOG_ID,
        from: 'home_page',
        code: locale,
      }) as Promise<ResultAPI>,
      serverSideTranslations(locale, ['common']),
    ]);

    return {
      props: {
        ...translations,
        blogs: blogsRes?.data || null,
      },
    };
  } catch (error) {
    return { notFound: true };
  }
});

